import { useQuery } from 'react-query'
import { getNavFolder } from '../../api/jobnumbers'

export function useNavFolderQuery(jobnumberId: number | undefined) {
  return useQuery(
    ['nav_folder', jobnumberId],
    () => getNavFolder(jobnumberId!),
    { enabled: !!jobnumberId }
  )
}
